import { render, staticRenderFns } from "./RecibosDeUnaPoliza.vue?vue&type=template&id=3a13bdb3&"
import script from "./RecibosDeUnaPoliza.vue?vue&type=script&lang=js&"
export * from "./RecibosDeUnaPoliza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports